//
// Copyright ArangoDB GmbH, Cologne, Germany
// All rights reserved. See LICENSE.md in the project root for license information.
//

import { ArangoPlatformBundle } from "../../api/data/v1/data";

/** Higher `priority` values first; missing priority treated as 0. */
export const sortArangoPlatformBundlesByPriorityDesc = (items: ArangoPlatformBundle[] | undefined): ArangoPlatformBundle[] =>
  [...(items ?? [])].sort((a, b) => (b.priority ?? 0) - (a.priority ?? 0));
